export enum TopBarMenuAcessoRapido {
  Assembleias,
  Presentes,
  Mensagens,
  Quorum,
}
